module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-halloween-0f650151b726c1efcde8bef7a2aee50e.svg";